export default () => (to, from, next) => {
  const config = window.__INITIAL_STATE__.config;
  if (['production', 'staging'].includes(config.environment)) next({ path: 'welcome' });
  else next();
};
